import * as analytics from '@gitbook/app-analytics/client';
import { Icon } from '@gitbook/spine-icons';
import { Button, Heading, Panel, PanelBody } from '@gitbook/spine-react';

import { AdaptiveContentFeatureIntro } from '../../../../../Components';
import { useNavigation } from '../../../../../navigation';
import { useSiteContext } from '../../../../../state';
import { createDocumentationURL } from '../../../../../utils';
import { AdaptiveContentSettings } from './AdaptiveContentSettings';

export function AdaptiveContentFeature() {
    const { organizationId, site } = useSiteContext();
    const { navigate } = useNavigation();

    return (
        <Panel>
            <div className="flex justify-between">
                <Heading level={2} id="adaptive-content">
                    Adaptive content
                </Heading>
                {site.adaptiveContent?.enabled ? (
                    <Button
                        kind="secondary"
                        label="Read the docs"
                        leadingIcon={Icon.HelpCircle}
                        target="_blank"
                        href={createDocumentationURL('publishing-documentation/adaptive-content')}
                    />
                ) : null}
            </div>
            <PanelBody>
                {!site.adaptiveContent?.enabled ? (
                    <AdaptiveContentFeatureIntro
                        onFeatureEnabled={() => {
                            analytics.logEvent(
                                analytics.createSiteEvent(
                                    {
                                        organization: organizationId,
                                        id: site.id,
                                    },
                                    {
                                        type: 'adaptive_content_enable',
                                        source: 'settings',
                                    }
                                )
                            );
                            navigate({
                                current: {
                                    tab: {
                                        type: 'settings',
                                        section: 'schema',
                                    },
                                },
                            });
                        }}
                    />
                ) : (
                    <AdaptiveContentSettings />
                )}
            </PanelBody>
        </Panel>
    );
}
